var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 51,
    viewBox: "0 0 113 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.446 5.61239L20.2444 3.41621C22.7174 2.8619 25.2826 2.8619 27.7556 3.41621L45.7276 7.4444C49.29 8.24288 52.4448 10.2996 54.6129 13.237C61.859 23.0543 75.8831 24.728 85.2361 16.8917L97.3713 6.7243C101.016 3.67049 106.557 4.82179 108.683 9.07486C110.199 12.1063 109.449 15.7809 106.867 17.976L97.9886 25.5224C93.9956 28.9164 93.8268 35.0234 97.6262 38.6328C99.7006 40.6035 97.8564 44.0533 95.0654 43.4231L73.1628 38.4774C69.9201 37.7451 66.526 38.1106 63.5134 39.5165L47.7052 46.8936C47.202 47.1285 46.6035 46.9914 46.2527 46.5609L40.7637 39.8244C36.3019 34.3485 27.6728 39.6505 30.5416 46.1052C30.5472 46.1178 30.5503 46.1269 30.552 46.1328C30.5493 46.1387 30.5437 46.1488 30.533 46.1608C30.5223 46.1728 30.5131 46.1796 30.5075 46.1831C30.5015 46.1821 30.492 46.1801 30.4789 46.1761L20.8641 43.2382C19.0517 42.6844 17.1243 42.6248 15.2811 43.0656L14.2301 43.3169C7.72329 44.8729 2.00531 38.7383 4.0143 32.3568L4.93543 29.4309C6.07901 25.7983 5.81098 21.8682 4.18481 18.4245C1.68659 13.1342 4.73711 6.89198 10.446 5.61239Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack12);
export default __webpack_public_path__ + "static/media/track12.5aed2245.svg";
export { ForwardRef as ReactComponent };